module.exports = __webpack_public_path__ + "img/disenio_publicidad.fead4f52.png";